import { takeEvery, call } from 'redux-saga/effects'

import { AUTH_FAILURE } from 'containers/app/constants'
import { config } from 'api/public'

export function* redirectToAuth() {
  const argusUrl = yield call(config, 'argus_url')
  window.location = `${argusUrl}/public/login/webapp-validate`
}

function* watchAuthFailure() {
  yield takeEvery(AUTH_FAILURE, redirectToAuth)
}

export default function* authRedirectSagas() {
  yield call(watchAuthFailure)
}
